
export const getAccessToken = (user) => {
  const accessToken = user.access_token;
  const idToken = user.id_token;
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("idToken", idToken);
};

export const getUserId = () => {
  const userId = localStorage.getItem("userId");
  return userId;
};

export const getIdToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  const idToken = localStorage.getItem("idToken");
  return { token: idToken, idToken: accessToken };
};

export const getImpersonatedUser = async () => {
  return localStorage.getItem("impersonated");
};

export const getRoles = (user) => {
  const delegatedUser = localStorage.getItem("impersonated");
  if (delegatedUser) {
    const decodedUser = JSON.parse(atob(delegatedUser));
    console.log(decodedUser);
    return decodedUser.roleId;
  }

  // const roles = JSON.parse(user.signInUserSession.idToken.payload.roles);
  // const roles = JSON.parse(user?.profile?.roles);
  // const roleIds = roles.map((role) => role.id)
  // return roleIds;
  // const adminRole = roles.find((role) => {
  //   return role.id === "SEC-IDM-CODES-ADMIN";
  // });
  // if (adminRole) {
  //   return adminRole.id;
  // } else {
  //   return roles[0].id;
  // }

  const roles = user?.profile?.roles;

  let roleIds = prepareRole(roles);

  const adminRole = roleIds.find((role) => {
    return role.id === "SEC-IDM-CODES-MG_GBCOSTAMKT1-ADMIN";
  });

  if (adminRole) {
    return adminRole.id;
  } else {
    return roleIds[0].id;
  }
};

export const prepareRole = (roles) => {
  let roleIds = [];
  roles.forEach((role) => {
    roleIds.push({ id: role, name: role });
  });
  return roleIds;
}

